export const enData = `
  <div class="paragraph">
    <div class="title">USER INFORMATION</div>
    <div class="text-box">
      <div class="text">
      Danghuan EUROPE S.L., as the Data Controller, informs you that in accordance with Regulation (EU) 2016/679 of April 27 (GDPR) and Organic Law 3/2018 of December 5, on the Protection of Personal Data and the Guarantee of Digital Rights (LOPDGDD), we will process your data as described in this Privacy Policy.
      </div>
      <div class="text">
      In this Privacy Policy, we describe how we collect your personal data, why we collect it, what we do with it, who we share it with, how we protect it, and your options regarding the processing of your personal data.
      </div>
      <div class="text">
      This Policy applies to the processing of your personal data collected by the company for the provision of its services. By agreeing to the terms of this Policy, you consent to the processing of your personal data as defined herein.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">CONTACT</div>
    <div class="text-box">
      <div class="text">
      1. Company Name: Danghuan EUROPE S.L.
      </div>
      <div class="text">
      Trade Name: Danghuan
      </div>
      <div class="text">
      CIF: B19961911
      </div>
      <div class="text">
      Address: Calle Tomás Bretón, 46, 28045, Madrid, Spain
      </div>
      <div class="text">
      Email: <span class="email">legal@eswop.eu</span>
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">KEY PRINCIPLES</div>
    <div class="text-box">
      <div class="text">
      1. We have always been committed to providing our services with the highest quality, which includes processing your data securely and transparently. Our principles are:
      </div>
      <div class="text">• Legality: We will only collect your personal data for specific, explicit, and legitimate purposes.</div>
      <div class="text">• Data Minimization: We limit the collection of personal data to what is strictly relevant and necessary for the purposes for which it was collected.</div>
      <div class="text">• Purpose Limitation: We will only collect your personal data for the stated purposes and only in accordance with your wishes.</div>
      <div class="text">• Accuracy: We will keep your personal data accurate and up to date.</div>
      <div class="text">• Data Security: We apply appropriate technical and organizational measures to protect your data from damage, such as unauthorized disclosure or access, </div>
      <div class="text">accidental or unlawful destruction, or alteration, and any other form of unlawful processing.</div>
      <div class="text">• Access and Rectification: We provide ways for you to access or rectify your data when necessary.</div>
      <div class="text">• Data Retention: We retain your personal data legally and appropriately and only for as long as necessary for the purposes for which it was collected.</div>
      <div class="text">• International Transfers: When your data is transferred outside the EU/EEA, it will be adequately protected.</div>
      <div class="text">• Third Parties: Access to and transfer of personal data to third parties will be carried out in accordance with applicable laws and regulations, with </div>
      <div class="text">appropriate contractual safeguards.</div>
      <div class="text">• Direct Marketing and Cookies: We comply with applicable legislation on advertising and cookies.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">COLLECTION AND PROCESSING OF PERSONAL DATA</div>
    <div class="text-box">
      <div class="text">
      The types of data that may be requested and processed include:
      </div>
      <div class="text">• Identification data. We also automatically collect data about your visit to our website as described in the cookie policy.</div>
      <div class="text">Whenever we request your personal data, we will clearly inform you about which personal data we collect and for what purpose. In general, we collect and </div>
      <div class="text">process your personal data to:</div>
      <div class="text">• Provide information, services, products, relevant information, and updates in the industry.</div>
      <div class="text">• Send communications.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">LEGAL BASIS</div>
    <div class="text-box">
      <div class="text">1. In accordance with the applicable data protection regulations, your personal data may be processed when:</div>
      <div class="text">• You have given your consent for processing purposes. Of course, you can withdraw your consent at any time.</div>
      <div class="text">• By legal requirement.</div>
      <div class="text">• Due to a legitimate interest that does not undermine your privacy rights, such as sending commercial information via subscription to our newsletter or your status as a customer.</div>
      <div class="text">• When necessary for the provision of our services through a contractual relationship between you and us.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">DISCLOSURE OF PERSONAL DATA</div>
    <div class="text-box">
      <div class="text">1. The data may be communicated to companies related to ESWOP EUROPE S.L. for the provision of various services as Data Processors. The company will not make any transfers except as required by law.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">YOUR RIGHTS</div>
    <div class="text-box">
      <div class="text">
      1. In relation to the collection and processing of your personal data, you can contact us at any time to:
      </div>
      <div class="text">• Access your personal data and any other information specified in Article 15.1 of the GDPR.</div>
      <div class="text">• Rectify your personal data that is inaccurate or incomplete in accordance with Article 16 of the GDPR.</div>
      <div class="text">• Delete your personal data in accordance with Article 17 of the GDPR.</div>
      <div class="text">• Limit the processing of your personal data in accordance with Article 18 of the GDPR.</div>
      <div class="text">• Request the portability of your data in accordance with Article 20 of the GDPR.</div>
      <div class="text">• Object to the processing of your personal data in accordance with Article 21 of the GDPR.</div>
      <div class="text">If you have given your consent for a specific purpose, you have the right to withdraw that consent at any time, without affecting the lawfulness of processing based on consent before its withdrawal.</div>
      <div class="text">You may exercise these rights by sending a motivated and accredited communication to <span class="email">legal@eswop.eu.</span></div>
      <div class="text">You also have the right to file a complaint with the competent supervisory authority (www.aepd.es) if you believe that the processing does not comply with the applicable regulations.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">LEGAL INFORMATION</div>
    <div class="text-box">
      <div class="text">
      8. The requirements of this Policy complement, and do not replace, any other existing requirements under applicable data protection law, which will prevail in any case.
      </div>
      <div class="text">
      This Policy is subject to periodic reviews, and the company may modify it at any time. When this happens, we will notify you of any changes and ask you to review the most recent version of our Policy and confirm your acceptance.</div>
    </div>
  </div>
`;
